// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ——— New reservation package (Stitch Clinical Precision) ——— */
.nrp-form {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  background: #ffffff;
}

.nrp-form__header {
  box-sizing: border-box;
  width: 100%;
  padding: 24px 32px 20px;
  border-bottom: 1px solid #E2E8F0;
  background: #ffffff;
  flex-shrink: 0;
}

.nrp-form__breadcrumb {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 14px;
  font-size: 12px;
  color: #94A3B8;
  line-height: 1.3;
}

.nrp-form__breadcrumb .lucide {
  color: #CBD5E1;
  flex-shrink: 0;
}

[dir='rtl'] .nrp-form__breadcrumb .lucide {
  transform: scaleX(-1);
}

.nrp-form__crumb {
  color: #94A3B8;
  text-decoration: none;
  transition: color 0.12s ease;
}

.nrp-form__crumb:hover {
  color: #0EA5E9;
}

.nrp-form__crumb--muted {
  pointer-events: none;
}

.nrp-form__crumb--current {
  color: #334155;
  font-weight: 500;
}

.nrp-form__title-row {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  min-width: 0;
}

.nrp-form__back {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  margin-top: 2px;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  background: #ffffff;
  color: #475569;
  cursor: pointer;
  flex-shrink: 0;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.nrp-form__back:hover {
  background: #F8FAFC;
  color: #0F172A;
}

[dir='rtl'] .nrp-form__back .lucide {
  transform: scaleX(-1);
}

.nrp-form__title {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: #0F172A;
  letter-spacing: -0.02em;
  line-height: 1.25;
}

.nrp-form__subtitle {
  margin: 2px 0 0;
  font-size: 14px;
  color: #64748B;
  line-height: 1.4;
}

.nrp-form__canvas {
  box-sizing: border-box;
  flex: 1;
  width: 100%;
  max-width: 64rem;
  margin: 0 auto;
  padding: 32px;
  min-width: 0;
}

.nrp-form__body {
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
  min-width: 0;
}

.nrp-form__section {
  padding-bottom: 32px;
  border-bottom: 1px solid rgba(226, 232, 240, 0.8);
}

.nrp-form__section--last {
  border-bottom: 0;
  padding-bottom: 0;
}

.nrp-form__section-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.nrp-form__section-title-wrap {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  min-width: 0;
}

.nrp-form__section-icon {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 12px;
  border: 1px solid #E0F2FE;
  background: #F0F9FF;
  color: #0284C7;
  flex-shrink: 0;
}

.nrp-form__section-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #0F172A;
  line-height: 1.3;
}

.nrp-form__section-subtitle {
  margin: 2px 0 0;
  font-size: 12px;
  color: #64748B;
  line-height: 1.4;
}

.nrp-form__count-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #94A3B8;
  white-space: nowrap;
}

.nrp-form__pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 10px;
  border-radius: 9999px;
  border: 1px solid #A7F3D0;
  background: #ECFDF5;
  color: #059669;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}

.nrp-form__pill--compact {
  padding: 2px 8px;
  font-size: 11px;
}

.nrp-form__pill-dot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background: #10B981;
  flex-shrink: 0;
}

.nrp-form__field {
  margin-bottom: 12px !important;
  max-width: 36rem;
}

.nrp-form__field .ant-form-item-label > label {
  font-size: 11px !important;
  font-weight: 700 !important;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #94A3B8 !important;
  height: auto !important;
}

.nrp-form__phone-select {
  width: 100%;
}

.nrp-form__phone-select.ant-select .ant-select-selector {
  height: 36px !important;
  border-radius: 12px !important;
  border-color: #E2E8F0 !important;
  font-size: 12px !important;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
}


.nrp-form__phone-select.ant-select-focused .ant-select-selector {
  border-color: #0EA5E9 !important;
  box-shadow: 0 0 0 1px #0EA5E9 !important;
}

.nrp-form__patient-card {
  box-sizing: border-box;
  margin-top: 8px;
  padding: 16px;
  border: 1px solid rgba(226, 232, 240, 0.8);
  border-radius: 12px;
  background: rgba(248, 250, 252, 0.7);
}

.nrp-form__patient-card-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.nrp-form__patient-identity {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}

.nrp-form__patient-avatar {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: #E0F2FE;
  color: #0369A1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  flex-shrink: 0;
}

.nrp-form__patient-name {
  font-size: 14px;
  font-weight: 600;
  color: #0F172A;
  line-height: 1.3;
}

.nrp-form__patient-meta {
  margin-top: 2px;
  font-size: 12px;
  color: #64748B;
  line-height: 1.4;
}

.nrp-form__patient-mrn {
  text-align: end;
}

.nrp-form__patient-mrn-label {
  display: block;
  font-size: 11px;
  color: #94A3B8;
}

.nrp-form__patient-mrn-value {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 14px;
  font-weight: 700;
  color: #0284C7;
}

.nrp-form__patient-card-foot {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 24px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(226, 232, 240, 0.6);
  font-size: 12px;
}

.nrp-form__patient-detail {
  display: flex;
  align-items: center;
  gap: 8px;
}

.nrp-form__patient-detail--end {
  margin-inline-start: auto;
}

.nrp-form__patient-detail-label {
  color: #94A3B8;
}

.nrp-form__patient-detail-value {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-weight: 500;
  color: #334155;
}

.nrp-form__table-card {
  box-sizing: border-box;
  border: 1px solid rgba(226, 232, 240, 0.8);
  border-radius: 12px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.nrp-form__table-scroll {
  width: 100%;
  overflow-x: auto;
}

.nrp-form__table {
  width: 100%;
  min-width: 720px;
  border-collapse: collapse;
  font-size: 12px;
  direction: inherit;
  text-align: start;
}

.nrp-form__table thead th {
  padding: 12px 16px;
  background: rgba(248, 250, 252, 0.8);
  border-bottom: 1px solid #E2E8F0;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748B;
  white-space: nowrap;
  text-align: start;
}

.nrp-form__table th.is-center,
.nrp-form__table td.is-center {
  text-align: center;
}

.nrp-form__table th.is-end,
.nrp-form__table td.is-end {
  text-align: end;
}

.nrp-form__table tbody td {
  padding: 16px;
  vertical-align: middle;
  border-bottom: 1px solid #F1F5F9;
  color: #334155;
  text-align: start;
  direction: inherit;
}

.nrp-form__table tbody tr:last-child td {
  border-bottom: 0;
}

.nrp-form__table tbody tr:hover td {
  background: rgba(248, 250, 252, 0.5);
}

.nrp-form__pkg-name {
  font-size: 14px;
  font-weight: 600;
  color: #0F172A;
  line-height: 1.3;
}

.nrp-form__pkg-meta {
  margin-top: 4px;
  font-size: 11px;
  color: #94A3B8;
}

.nrp-form__category {
  display: inline-flex;
  padding: 4px 10px;
  border-radius: 6px;
  background: #F1F5F9;
  color: #334155;
  font-size: 12px;
  font-weight: 500;
}

.nrp-form__stepper {
  display: inline-flex;
  align-items: center;
  height: 32px;
  padding: 0 4px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.nrp-form__stepper-btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #94A3B8;
  cursor: pointer;
}

.nrp-form__stepper-btn:hover:not(:disabled) {
  color: #0F172A;
  background: #F8FAFC;
}

.nrp-form__stepper-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.nrp-form__stepper-value {
  width: 28px;
  text-align: center;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  font-weight: 600;
  color: #1E293B;
}

.nrp-form__quota-hint {
  margin-top: 4px;
  font-size: 11px;
  color: #94A3B8;
}

.nrp-form__line-price {
  display: inline-block;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 14px;
  font-weight: 700;
  color: #0F172A;
  font-variant-numeric: tabular-nums;
  unicode-bidi: isolate;
}

.nrp-form__icon-btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #94A3B8;
  cursor: pointer;
}

.nrp-form__icon-btn--danger:hover {
  color: #E11D48;
  background: #FFF1F2;
}

.nrp-form__packages-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 40px 16px;
  text-align: center;
  color: #94A3B8;
  font-size: 13px;
}

.nrp-form__packages-empty p {
  margin: 0;
}

.nrp-form__packages-foot {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 12px;
}

.nrp-form__totals {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 20px;
  font-size: 12px;
  color: #94A3B8;
}

.nrp-form__total-line strong {
  margin-inline-start: 4px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-weight: 600;
  color: #1E293B;
  font-variant-numeric: tabular-nums;
}

.nrp-form__total-due {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-inline-start: 16px;
  border-inline-start: 1px solid #E2E8F0;
  color: #334155;
  font-weight: 500;
}

.nrp-form__total-due strong {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 16px;
  font-weight: 700;
  color: #0F172A;
  font-variant-numeric: tabular-nums;
}

.nrp-form__packages-validator {
  margin: 0 !important;
  height: 0;
  overflow: hidden;
}

.nrp-form__picker-select.ant-select .ant-select-selector {
  border-radius: 8px !important;
}

.nrp-form__error {
  margin: 0;
  font-size: 13px;
  color: #E11D48;
}

.nrp-form__btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 16px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.nrp-form__btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.nrp-form__btn--ghost {
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #334155;
}

.nrp-form__btn--ghost:hover:not(:disabled) {
  background: #F8FAFC;
}

.nrp-form__btn--primary {
  border: 1px solid #0EA5E9;
  background: #0EA5E9;
  color: #ffffff;
}

.nrp-form__btn--primary:hover:not(:disabled) {
  background: #0284C7;
  border-color: #0284C7;
}

.nrp-form__btn--primary .lucide {
  color: #ffffff;
}

.nrp-form__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding: 14px 32px;
  border-top: 1px solid rgba(226, 232, 240, 0.8);
  background: #ffffff;
  flex-shrink: 0;
  margin-top: auto;
}

.nrp-form__footer-end {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.nrp-form__payable {
  text-align: end;
}

.nrp-form__payable-label {
  display: block;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #94A3B8;
}

.nrp-form__payable-value {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 14px;
  font-weight: 700;
  color: #0284C7;
  font-variant-numeric: tabular-nums;
}

@media (max-width: 768px) {
  .nrp-form__header,
  .nrp-form__canvas,
  .nrp-form__footer {
    padding-inline: 16px;
  }

  .nrp-form__title {
    font-size: 20px;
  }

  .nrp-form__footer {
    flex-direction: column;
    align-items: stretch;
  }

  .nrp-form__footer-end {
    width: 100%;
    justify-content: space-between;
  }

  .nrp-form__footer .nrp-form__btn--primary {
    flex: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/NewReservationPackage/style.css"],"names":[],"mappings":"AAAA,gEAAgE;AAChE;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,gCAAgC;EAChC,0BAA0B;EAC1B,6EAA6E;AAC/E;;;AAGA;EACE,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,6EAA6E;EAC7E,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6EAA6E;EAC7E,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,6EAA6E;EAC7E,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,6EAA6E;EAC7E,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,6EAA6E;EAC7E,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,sCAAsC;EACtC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,6EAA6E;EAC7E,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,4EAA4E;EAC5E,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,8CAA8C;EAC9C,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,6EAA6E;EAC7E,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE;;;IAGE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,OAAO;EACT;AACF","sourcesContent":["/* ——— New reservation package (Stitch Clinical Precision) ——— */\n.nrp-form {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  min-height: 100%;\n  display: flex;\n  flex-direction: column;\n  background: #ffffff;\n}\n\n.nrp-form__header {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 24px 32px 20px;\n  border-bottom: 1px solid #E2E8F0;\n  background: #ffffff;\n  flex-shrink: 0;\n}\n\n.nrp-form__breadcrumb {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-bottom: 14px;\n  font-size: 12px;\n  color: #94A3B8;\n  line-height: 1.3;\n}\n\n.nrp-form__breadcrumb .lucide {\n  color: #CBD5E1;\n  flex-shrink: 0;\n}\n\n[dir='rtl'] .nrp-form__breadcrumb .lucide {\n  transform: scaleX(-1);\n}\n\n.nrp-form__crumb {\n  color: #94A3B8;\n  text-decoration: none;\n  transition: color 0.12s ease;\n}\n\n.nrp-form__crumb:hover {\n  color: #0EA5E9;\n}\n\n.nrp-form__crumb--muted {\n  pointer-events: none;\n}\n\n.nrp-form__crumb--current {\n  color: #334155;\n  font-weight: 500;\n}\n\n.nrp-form__title-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  min-width: 0;\n}\n\n.nrp-form__back {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  margin-top: 2px;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  background: #ffffff;\n  color: #475569;\n  cursor: pointer;\n  flex-shrink: 0;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.nrp-form__back:hover {\n  background: #F8FAFC;\n  color: #0F172A;\n}\n\n[dir='rtl'] .nrp-form__back .lucide {\n  transform: scaleX(-1);\n}\n\n.nrp-form__title {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  color: #0F172A;\n  letter-spacing: -0.02em;\n  line-height: 1.25;\n}\n\n.nrp-form__subtitle {\n  margin: 2px 0 0;\n  font-size: 14px;\n  color: #64748B;\n  line-height: 1.4;\n}\n\n.nrp-form__canvas {\n  box-sizing: border-box;\n  flex: 1;\n  width: 100%;\n  max-width: 64rem;\n  margin: 0 auto;\n  padding: 32px;\n  min-width: 0;\n}\n\n.nrp-form__body {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  width: 100%;\n  min-width: 0;\n}\n\n.nrp-form__section {\n  padding-bottom: 32px;\n  border-bottom: 1px solid rgba(226, 232, 240, 0.8);\n}\n\n.nrp-form__section--last {\n  border-bottom: 0;\n  padding-bottom: 0;\n}\n\n.nrp-form__section-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n}\n\n.nrp-form__section-title-wrap {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  min-width: 0;\n}\n\n.nrp-form__section-icon {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 12px;\n  border: 1px solid #E0F2FE;\n  background: #F0F9FF;\n  color: #0284C7;\n  flex-shrink: 0;\n}\n\n.nrp-form__section-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #0F172A;\n  line-height: 1.3;\n}\n\n.nrp-form__section-subtitle {\n  margin: 2px 0 0;\n  font-size: 12px;\n  color: #64748B;\n  line-height: 1.4;\n}\n\n.nrp-form__count-label {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #94A3B8;\n  white-space: nowrap;\n}\n\n.nrp-form__pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 2px 10px;\n  border-radius: 9999px;\n  border: 1px solid #A7F3D0;\n  background: #ECFDF5;\n  color: #059669;\n  font-size: 12px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.nrp-form__pill--compact {\n  padding: 2px 8px;\n  font-size: 11px;\n}\n\n.nrp-form__pill-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 9999px;\n  background: #10B981;\n  flex-shrink: 0;\n}\n\n.nrp-form__field {\n  margin-bottom: 12px !important;\n  max-width: 36rem;\n}\n\n.nrp-form__field .ant-form-item-label > label {\n  font-size: 11px !important;\n  font-weight: 700 !important;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #94A3B8 !important;\n  height: auto !important;\n}\n\n.nrp-form__phone-select {\n  width: 100%;\n}\n\n.nrp-form__phone-select.ant-select .ant-select-selector {\n  height: 36px !important;\n  border-radius: 12px !important;\n  border-color: #E2E8F0 !important;\n  font-size: 12px !important;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n}\n\n\n.nrp-form__phone-select.ant-select-focused .ant-select-selector {\n  border-color: #0EA5E9 !important;\n  box-shadow: 0 0 0 1px #0EA5E9 !important;\n}\n\n.nrp-form__patient-card {\n  box-sizing: border-box;\n  margin-top: 8px;\n  padding: 16px;\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  border-radius: 12px;\n  background: rgba(248, 250, 252, 0.7);\n}\n\n.nrp-form__patient-card-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.nrp-form__patient-identity {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  min-width: 0;\n}\n\n.nrp-form__patient-avatar {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  background: #E0F2FE;\n  color: #0369A1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.nrp-form__patient-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #0F172A;\n  line-height: 1.3;\n}\n\n.nrp-form__patient-meta {\n  margin-top: 2px;\n  font-size: 12px;\n  color: #64748B;\n  line-height: 1.4;\n}\n\n.nrp-form__patient-mrn {\n  text-align: end;\n}\n\n.nrp-form__patient-mrn-label {\n  display: block;\n  font-size: 11px;\n  color: #94A3B8;\n}\n\n.nrp-form__patient-mrn-value {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 14px;\n  font-weight: 700;\n  color: #0284C7;\n}\n\n.nrp-form__patient-card-foot {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 24px;\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid rgba(226, 232, 240, 0.6);\n  font-size: 12px;\n}\n\n.nrp-form__patient-detail {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.nrp-form__patient-detail--end {\n  margin-inline-start: auto;\n}\n\n.nrp-form__patient-detail-label {\n  color: #94A3B8;\n}\n\n.nrp-form__patient-detail-value {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-weight: 500;\n  color: #334155;\n}\n\n.nrp-form__table-card {\n  box-sizing: border-box;\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  border-radius: 12px;\n  overflow: hidden;\n  background: #ffffff;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.nrp-form__table-scroll {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.nrp-form__table {\n  width: 100%;\n  min-width: 720px;\n  border-collapse: collapse;\n  font-size: 12px;\n  direction: inherit;\n  text-align: start;\n}\n\n.nrp-form__table thead th {\n  padding: 12px 16px;\n  background: rgba(248, 250, 252, 0.8);\n  border-bottom: 1px solid #E2E8F0;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748B;\n  white-space: nowrap;\n  text-align: start;\n}\n\n.nrp-form__table th.is-center,\n.nrp-form__table td.is-center {\n  text-align: center;\n}\n\n.nrp-form__table th.is-end,\n.nrp-form__table td.is-end {\n  text-align: end;\n}\n\n.nrp-form__table tbody td {\n  padding: 16px;\n  vertical-align: middle;\n  border-bottom: 1px solid #F1F5F9;\n  color: #334155;\n  text-align: start;\n  direction: inherit;\n}\n\n.nrp-form__table tbody tr:last-child td {\n  border-bottom: 0;\n}\n\n.nrp-form__table tbody tr:hover td {\n  background: rgba(248, 250, 252, 0.5);\n}\n\n.nrp-form__pkg-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #0F172A;\n  line-height: 1.3;\n}\n\n.nrp-form__pkg-meta {\n  margin-top: 4px;\n  font-size: 11px;\n  color: #94A3B8;\n}\n\n.nrp-form__category {\n  display: inline-flex;\n  padding: 4px 10px;\n  border-radius: 6px;\n  background: #F1F5F9;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.nrp-form__stepper {\n  display: inline-flex;\n  align-items: center;\n  height: 32px;\n  padding: 0 4px;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: #ffffff;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.nrp-form__stepper-btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: #94A3B8;\n  cursor: pointer;\n}\n\n.nrp-form__stepper-btn:hover:not(:disabled) {\n  color: #0F172A;\n  background: #F8FAFC;\n}\n\n.nrp-form__stepper-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.nrp-form__stepper-value {\n  width: 28px;\n  text-align: center;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 12px;\n  font-weight: 600;\n  color: #1E293B;\n}\n\n.nrp-form__quota-hint {\n  margin-top: 4px;\n  font-size: 11px;\n  color: #94A3B8;\n}\n\n.nrp-form__line-price {\n  display: inline-block;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 14px;\n  font-weight: 700;\n  color: #0F172A;\n  font-variant-numeric: tabular-nums;\n  unicode-bidi: isolate;\n}\n\n.nrp-form__icon-btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: #94A3B8;\n  cursor: pointer;\n}\n\n.nrp-form__icon-btn--danger:hover {\n  color: #E11D48;\n  background: #FFF1F2;\n}\n\n.nrp-form__packages-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 40px 16px;\n  text-align: center;\n  color: #94A3B8;\n  font-size: 13px;\n}\n\n.nrp-form__packages-empty p {\n  margin: 0;\n}\n\n.nrp-form__packages-foot {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-top: 12px;\n}\n\n.nrp-form__totals {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 20px;\n  font-size: 12px;\n  color: #94A3B8;\n}\n\n.nrp-form__total-line strong {\n  margin-inline-start: 4px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-weight: 600;\n  color: #1E293B;\n  font-variant-numeric: tabular-nums;\n}\n\n.nrp-form__total-due {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding-inline-start: 16px;\n  border-inline-start: 1px solid #E2E8F0;\n  color: #334155;\n  font-weight: 500;\n}\n\n.nrp-form__total-due strong {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 16px;\n  font-weight: 700;\n  color: #0F172A;\n  font-variant-numeric: tabular-nums;\n}\n\n.nrp-form__packages-validator {\n  margin: 0 !important;\n  height: 0;\n  overflow: hidden;\n}\n\n.nrp-form__picker-select.ant-select .ant-select-selector {\n  border-radius: 8px !important;\n}\n\n.nrp-form__error {\n  margin: 0;\n  font-size: 13px;\n  color: #E11D48;\n}\n\n.nrp-form__btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 16px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.nrp-form__btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.nrp-form__btn--ghost {\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  color: #334155;\n}\n\n.nrp-form__btn--ghost:hover:not(:disabled) {\n  background: #F8FAFC;\n}\n\n.nrp-form__btn--primary {\n  border: 1px solid #0EA5E9;\n  background: #0EA5E9;\n  color: #ffffff;\n}\n\n.nrp-form__btn--primary:hover:not(:disabled) {\n  background: #0284C7;\n  border-color: #0284C7;\n}\n\n.nrp-form__btn--primary .lucide {\n  color: #ffffff;\n}\n\n.nrp-form__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  padding: 14px 32px;\n  border-top: 1px solid rgba(226, 232, 240, 0.8);\n  background: #ffffff;\n  flex-shrink: 0;\n  margin-top: auto;\n}\n\n.nrp-form__footer-end {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.nrp-form__payable {\n  text-align: end;\n}\n\n.nrp-form__payable-label {\n  display: block;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #94A3B8;\n}\n\n.nrp-form__payable-value {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 14px;\n  font-weight: 700;\n  color: #0284C7;\n  font-variant-numeric: tabular-nums;\n}\n\n@media (max-width: 768px) {\n  .nrp-form__header,\n  .nrp-form__canvas,\n  .nrp-form__footer {\n    padding-inline: 16px;\n  }\n\n  .nrp-form__title {\n    font-size: 20px;\n  }\n\n  .nrp-form__footer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .nrp-form__footer-end {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .nrp-form__footer .nrp-form__btn--primary {\n    flex: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
